import { useState } from "react";
import "./SkillsSection.css";

// Skills Section - Champion Ability Style
export default function SkillsSection({ skills }) {
  const [activeSkill, setActiveSkill] = useState(skills[0]);

  return (
    <section
      id="skills"
      className="py-24 lg:py-32 bg-[#091428]"
      data-testid="skills-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <h2 className="font-['Marcellus'] text-3xl sm:text-4xl text-[#F0E6D2] text-center mb-16 tracking-tight">
          Abilities
        </h2>

        {/* Ability Icons Row */}
        <div className="flex justify-center gap-2 sm:gap-6 mb-8 stagger-children">
          {skills.map((skill) => {
            const Icon = skill.icon;
            return (
              <button
                key={skill.key}
                className={`ability-btn opacity-0 animate-fade-in-up ${
                  activeSkill.key === skill.key ? "active" : ""
                }`}
                onClick={() => setActiveSkill(skill)}
                data-testid={`ability-${skill.key.toLowerCase()}`}
              >
                <Icon
                  size={28}
                  className={
                    activeSkill.key === skill.key
                      ? "text-[#0AC8B9]"
                      : "text-[#A09B8C]"
                  }
                />
                <span className="ability-key">{skill.key}</span>
              </button>
            );
          })}
        </div>

        {/* Ability Description */}
        <div className="max-w-2xl mx-auto">
          <div
            className="ability-description"
            style={{ "--ability-line-x": activeSkill.position }}
            data-testid="ability-description"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-['Marcellus'] text-l sm:text-xl text-[#F0E6D2] uppercase tracking-wider">
                {activeSkill.name}
              </h3>
              <span className="text-xs text-[#0AC8B9] uppercase tracking-widest">
                {activeSkill.cooldown}
              </span>
            </div>
            <p className="text-[#A09B8C] leading-relaxed mb-6">
              {activeSkill.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
